export default function LibraryClosedSept2026() {
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button className="accordion-button caret-off collapsed yellow-background" type="button" data-bs-toggle="collapse" data-bs-target="#collapseLibraryClosedSept2026">
          <i className="fa-solid fa-book-open fa-2xl feature-icon af-icon"></i>
          <b>Library Closed For Renovations&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>
          <span className="badge text-bg-success">LIBRARY</span>
        </button>
      </h2>
      <div id="collapseLibraryClosedSept2026" className="accordion-collapse" data-bs-parent="#latestNewsAccordion">
        <div className="accordion-body">
            <a href="../img/flyers/flyer-2026-library-closed-sept.png"><img src="../img/flyers/flyer-2026-library-closed-sept.png" width="100%"/></a>
          <h4>
            As of Sept 5, 2026, the Morrisville Free Library will be closed for renovations.
          </h4>
          Stay up to date by keeping up with Library's socials:<br/>
          <ul>
            <li><a href="https://www.morrisvillepalibrary.org/">https://www.morrisvillepalibrary.org</a></li>
            <li><a href="https://www.facebook.com/MorrisvilleFreeLibrary">https://www.facebook.com/MorrisvilleFreeLibrary</a></li>
            <li><a href="https://www.instagram.com/morrisvillefreelibrarypa/">https://www.instagram.com/morrisvillefreelibrarypa/</a></li>
          </ul>
          
        </div>
      </div>
    </div>
  );
}
